exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#create-reminder-modal .add-list{display:flex;flex-direction:column}#create-reminder-modal .add-list>div{margin:5px 0;display:flex;align-items:center}#create-reminder-modal .alert-days-field{width:100px;display:inline-block;margin-right:20px;padding:6px 12px;font-size:1.2em;text-align:right}", ""]);

